import { Component } from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as userActions from '../../actions/userActions';

/*
Component to load user state (from the Auth app).
Should be included in all pages
*/
export class UserData extends Component {
  componentDidMount() {
    // Load info on the current user into state
    this.props.userActions.fetchUserData();
  }
  render() {
    return null;
  }
}

UserData.propTypes = {
  userActions: PropTypes.object,
  userData: PropTypes.object
};

function mapStateToProps(state) {
  return {
    userData: state.userData
  };
}

function mapDispatchToProps(dispatch) {
  return {
    userActions: bindActionCreators(userActions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserData);
